import fetchServer from "../fetchServer";

/**
 * First-time verification reject (no business-change request yet).
 * PATCH /main/v1/account/rejectBusinessVerification/:id { reason }
 */
export default async function rejectInitialBusinessVerification(id, reason) {
  let result = {
    return: 0,
    msg: "Something went wrong rejecting verification!",
  };

  if (!id) {
    result.msg = "Missing account id.";
    return result;
  }

  await fetchServer({
    method: "PATCH",
    url: `/main/v1/account/rejectBusinessVerification/${encodeURIComponent(id)}`,
    data: { reason: String(reason || "").trim() },
  })
    .then((res) => {
      if (
        res?.data &&
        !res?.data?.error &&
        res?.status >= 200 &&
        res?.status < 300
      ) {
        result = {
          return: 1,
          msg: res.data?.message || "Rejected",
          data: res.data?.data || res.data,
        };
      } else {
        result.msg = res?.data?.error || res?.data?.message || result.msg;
      }
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}
